'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider.state('oauthDone', {
      url: '/oauthDone?create_sandbox',
      template: '<oauth-done></oauth-done>'
    });
}



// WEBPACK FOOTER //
// ./client/app/oauthDone/oauthDone.routes.js